/*
 * METAX — κάρτες «Μπορεί να σας αρέσουν»
 * - Βελάκια (υπολογιστής) και τελείες για τις φωτογραφίες· στο κινητό σύρσιμο (CSS scroll-snap).
 * - Το πάτημα χρώματος αλλάζει την κάρτα επί τόπου (φωτογραφίες, σύνδεσμοι, όνομα, τιμή, έκπτωση,
 *   διαθεσιμότητα) αντί να ανοίγει το προϊόν. Χωρίς JS τα χρώματα μένουν απλοί σύνδεσμοι.
 * Delegated listeners στο document: οι κάρτες έρχονται με AJAX (product-recommendations.js).
 */
(() => {
  if (window.__metaxRecCardsBound) return;
  window.__metaxRecCardsBound = true;

  const CARD = '.metax-rec-card';

  const getTrack = (card) => card.querySelector('[data-rec-track]');
  const slideCount = (track) => (track ? track.querySelectorAll('.metax-rec-card__slide').length : 0);
  const activeIndex = (track) => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));

  const updateDots = (card) => {
    const track = getTrack(card);
    const dots = card.querySelector('[data-rec-dots]');
    if (!track || !dots) return;
    const index = activeIndex(track);
    dots.querySelectorAll('.metax-rec-card__dot').forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  };

  const renderControls = (card) => {
    const track = getTrack(card);
    const count = slideCount(track);
    const dots = card.querySelector('[data-rec-dots]');

    card.querySelectorAll('[data-rec-arrow]').forEach((arrow) => {
      arrow.hidden = count <= 1;
    });

    if (dots) {
      dots.hidden = count <= 1;
      dots.replaceChildren();
      for (let i = 0; i < count; i += 1) {
        const dot = document.createElement('span');
        dot.className = 'metax-rec-card__dot' + (i === 0 ? ' is-active' : '');
        dots.append(dot);
      }
    }
  };

  const setText = (element, text) => {
    if (element) element.textContent = text;
  };

  const swapColour = (card, swatch) => {
    if (swatch.classList.contains('is-active')) return;

    const data = swatch.dataset;
    const track = getTrack(card);
    const template = swatch.querySelector('template[data-rec-slides]');

    if (track && template && template.content.childElementCount > 0) {
      track.replaceChildren(template.content.cloneNode(true));
      track.scrollLeft = 0;
    }

    card
      .querySelectorAll('a.metax-rec-card__media-link, a.metax-rec-card__brand, a.metax-rec-card__model')
      .forEach((link) => {
        link.href = data.url;
      });

    const mediaLink = card.querySelector('.metax-rec-card__media-link');
    if (mediaLink) mediaLink.setAttribute('aria-label', data.title || '');

    setText(card.querySelector('.metax-rec-card__model'), data.name || '');
    setText(card.querySelector('.metax-rec-card__price'), data.price || '');

    const compare = card.querySelector('.metax-rec-card__compare');
    if (compare) {
      compare.textContent = data.compare || '';
      compare.hidden = !data.compare;
    }

    const discount = card.querySelector('.metax-rec-card__discount');
    const discountValue = Number(data.discount || 0);
    if (discount) {
      discount.textContent = discountValue > 0 ? `-${discountValue}%` : '';
      discount.hidden = !(discountValue > 0);
    }

    setText(card.querySelector('[data-rec-active-index]'), data.index || '');

    const availability = card.querySelector('.metax-rec-card__availability');
    if (availability) {
      const available = data.available === 'true';
      availability.classList.toggle('is-unavailable', !available);
      availability.textContent = available ? card.dataset.labelAvailable : card.dataset.labelUnavailable;
    }

    card.querySelectorAll('[data-rec-swatch]').forEach((item) => {
      item.classList.toggle('is-active', item === swatch);
    });

    if (data.productId) card.dataset.productId = data.productId;

    renderControls(card);
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const arrow = event.target.closest(`${CARD} [data-rec-arrow]`);
    if (arrow) {
      event.preventDefault();
      const card = arrow.closest(CARD);
      const track = getTrack(card);
      const count = slideCount(track);
      if (!track || count <= 1) return;
      let index = activeIndex(track) + (arrow.dataset.recArrow === 'next' ? 1 : -1);
      if (index < 0) index = count - 1;
      if (index >= count) index = 0;
      track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
      return;
    }

    const swatch = event.target.closest(`${CARD} [data-rec-swatch]`);
    if (!swatch) return;

    // Ctrl/Cmd/Shift-click: άνοιγμα σε νέα καρτέλα όπως πριν.
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    swapColour(swatch.closest(CARD), swatch);
  });

  document.addEventListener(
    'scroll',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element) || !target.matches('[data-rec-track]')) return;
      const card = target.closest(CARD);
      if (card) updateDots(card);
    },
    { capture: true, passive: true }
  );
})();
